<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/library/free">Бесплатные книги</router-link>
          <span></span>
          <h1>Создание книги</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="block_flex">
          <div class="left">
            <div class="folder radius">
              <div class="column caption">
                <p>Основные настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <form-input name="title"></form-input>
                  <form-input name="creator"></form-input>
                  <form-input name="year"></form-input>
                  <form-drop-down title="title" name="author_id" :id="parentId.authors"
                                  :url="apiUrls.content"></form-drop-down>
                  <div class="list">
                    <p>Настройки отображения</p>
                    <div class="checkbox-group">
                      <checkbox name="show_author"></checkbox>
                      <checkbox name="show_date"></checkbox>
                    </div>
                  </div>
                  <form-file use-case="cover" name="img"></form-file>
                  <form-input name="seo_alt"></form-input>
                  <form-file name="file" uploadFront="true" folder="books"></form-file>
                  <form-text-area name="subtext"></form-text-area>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="folder radius">
              <div class="column caption">
                <p>СЕО настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <form-input name="seo_title"></form-input>
                  <form-text-area name="seo_desc"></form-text-area>
                  <form-text-area name="seo_key"></form-text-area>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="folder radius">
          <div class="column caption">
            <p>Текст статьи</p>
          </div>
          <div class="column">
            <div class="content">
              <form-text-editor name="text" editor-id="editor"></form-text-editor>
              <add-image v-if="isLoaded"/>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onAddItem">Сохранить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import Checkbox from '@/components/create-form/Checkbox'
  import AddImage from '@/components/edit-form/AddImage'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    data: function () {
      return {
        editorInstance: '',
        isLoaded: false,
        text: '',
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'textContent',
        'fields'
      ]),
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions',
        'setCurrentParentId',
        'setUrl'
      ]),
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
          .then(() => {
          this.$router.push('/library/free')
        })
      },
    },
    mounted() {
      this.isLoaded = true
    },
    created () {
      this.setUrl(this.apiUrls.content)
      this.setCurrentParentId(this.parentId.library.free)
      this.setFileExtensions({
        img: ['jpg', 'jpeg', 'png', 'gif'],
        file: ['fb2', 'pdf', 'doc', 'docx', 'epub', 'mobi', 'kf8', 'djvu', 'txt', 'rtf']
      })
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название книги',
          errorId: null,
          errors: {empty: 'Введите название книги'},
          tabId: 0
        },
        url: {
          value: '',
          parameterName: 'url',
          errorId: null,
          isNullable: true,
          tabId: 0
        },
        author_id: {
          value: '',
          parameterName: 'author_id',
          name: 'Автор статьи',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Выберите эксперта'},
          tabId: 0,
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Альтернативный текст',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Введите альтернативный текст'},
          tabId: 0
        },
        creator: {
          value: '',
          parameterName: 'creator',
          name: 'Автор книги',
          errorId: null,
          type: 'object',
          isNullable: true,
          errors: {empty: 'Введите автора книги'},
          tabId: 0
        },
        year: {
          value: '',
          parameterName: 'year',
          name: 'Год издания',
          errorId: null,
          type: 'object',
          errors: {empty: 'Введите год издания книги'},
          tabId: 0
        },
        file: {
          value: '',
          parameterName: 'file',
          name: 'Файл книги',
          errorId: null,
          type: 'object',
          errors: {
            empty: 'Загрузите файл книги',
            extension: 'Допустимые расширения: fb2, pdf, doc, docx, epub, mobi, kf8, djvu, txt, rtf'
          },
          tabId: 0
        },
        show_author: {
          value: true,
          parameterName: 'show_author',
          name: 'Отображать автора',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        show_date: {
          value: true,
          parameterName: 'show_date',
          name: 'Отображать дату',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        subtext: {
          value: '',
          parameterName: 'subtext',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Введите краткое описание'},
          tabId: 0,
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0,
          isNullable: true
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
        downloads_amount: {
          value: 0,
          parameterName: 'downloads_amount',
          type: 'object',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
        reads_amount: {
          value: 0,
          parameterName: 'reads_amount',
          type: 'object',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        }
      })
    },
    components: {
      Checkbox,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      AddImage
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/library/free-books/pages/Create.vue